import {
    MoreHorizontal,
    TowerControlIcon
} from "lucide-react"

import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu, SidebarMenuButton,
    SidebarMenuItem
} from "@/components/ui/sidebar"
import { useSensorsQueryV1 } from "@/api/v1/sensor-api"
import { Link } from "@tanstack/react-router"



export function NavSensors() {

    const { data: sensors, isPending, isError } = useSensorsQueryV1()


    return (
        <SidebarGroup className="group-data-[collapsible=icon]:hidden">
            <SidebarGroupLabel>Sensors</SidebarGroupLabel>
            <SidebarMenu>
                {isPending && <p>loading..</p>}
                {isError && <p>Something bad happened</p>}
                {sensors?.slice(0, 3).map((item) => {
                    const sensorId = item.slug || item.organisation_id.toString();
                    return (
                        <SidebarMenuItem key={item.name}>
                            <SidebarMenuButton asChild>
                                <Link to={'/sensors/$sensorId'} params={{ sensorId }}>
                                    <TowerControlIcon />
                                    <span>{item.name}</span>
                                </Link>
                            </SidebarMenuButton>
                        </SidebarMenuItem>
                    );
                })}
                <SidebarMenuItem>
                    <Link to="/sensors">
                        <SidebarMenuButton className="text-sidebar-foreground/70">
                            <MoreHorizontal className="text-sidebar-foreground/70" />
                            <span>More</span>
                        </SidebarMenuButton>
                    </Link>
                </SidebarMenuItem>
            </SidebarMenu>
        </SidebarGroup>
    )
}
